(function () {
  if (window.__jojoListingTrackingBoot) return;
  window.__jojoListingTrackingBoot = true;

  var thresholds = [];
  for (var step = 0; step <= 10; step += 1) {
    thresholds.push(step / 10);
  }

  function pushGa4(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: params,
    });
  }

  function gaParams(el) {
    var params = {};
    Array.prototype.forEach.call(el.attributes, function (attr) {
      if (attr.name.indexOf('data-ga4-') !== 0) return;
      var name = attr.name.slice('data-ga4-'.length).replace(/-/g, '_');
      params[name] = attr.value;
    });
    return params;
  }

  function meetsExposure(entry) {
    if (entry.intersectionRatio >= 0.1) return true;
    var visibleHeight = entry.intersectionRect ? entry.intersectionRect.height : 0;
    return visibleHeight >= window.innerHeight * 0.1;
  }

  function isBottomInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom > 0 && rect.bottom <= windowHeight;
  }

  function bindBottomImpression(root, moduleName) {
    function onScroll() {
      if (!root.isConnected) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }
      if (!isBottomInViewport(root)) return;
      pushGa4('module_impression', { module: moduleName });
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  function bindRoot(root) {
    if (!root || root.dataset.jojoGaReady === 'true') return;
    root.dataset.jojoGaReady = 'true';

    var moduleName = root.getAttribute('data-jojo-ga-module');
    if (moduleName && root.getAttribute('data-jojo-ga-impression') === 'bottom') {
      bindBottomImpression(root, moduleName);
    } else if (moduleName && 'IntersectionObserver' in window) {
      var target = root.querySelector('[data-jojo-product-pin], [data-jojo-story-sticky]') || root;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || !meetsExposure(entry)) return;
            pushGa4('module_impression', { module: moduleName });
            observer.disconnect();
          });
        },
        { threshold: thresholds }
      );
      observer.observe(target);
    }

    root.addEventListener('click', function (event) {
      var node = event.target;
      var selectItem = node && node.closest ? node.closest('[data-ga4-event="select_item"]') : null;
      if (selectItem && root.contains(selectItem)) {
        var owner = selectItem.closest('[data-jojo-ga-module]');
        if (owner !== root) return;
        var raw = selectItem.getAttribute('data-select-item');
        if (!raw) return;
        var now = Date.now();
        var last = Number(selectItem.dataset.jojoSelectAt || 0);
        if (now - last < 400) return;
        selectItem.dataset.jojoSelectAt = String(now);
        event.stopPropagation();
        try {
          pushGa4('select_item', JSON.parse(raw));
        } catch (error) {}
        return;
      }
      var target = node && node.closest ? node.closest('[data-ga4-button-name]') : null;
      if (!target || !root.contains(target)) return;
      pushGa4('select_content', gaParams(target));
    });
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[data-jojo-ga-module]')) {
      bindRoot(context);
    }
    context.querySelectorAll('[data-jojo-ga-module]').forEach(bindRoot);
  }

  function boot() {
    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
